import { render, staticRenderFns } from "./SortBody.vue?vue&type=template&id=abbf6c5c&scoped=true&"
import script from "./SortBody.vue?vue&type=script&lang=js&"
export * from "./SortBody.vue?vue&type=script&lang=js&"
import style0 from "./SortBody.vue?vue&type=style&index=0&id=abbf6c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbf6c5c",
  null
  
)

export default component.exports